import React, { useState, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import config from '../functions/config';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
  faTrash,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";


const ListUserPage = () => {
  const [users, setUsers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  // Fetch users from the backend
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-users/`);

      if (response.ok) {
        const data = await response.json();

        // Order by Pending first, then Approved, then Disapproved
        const orderedUsers = data.users.sort((a, b) => {
          if (a.is_superuser && !b.is_superuser) return -1;
          if (!a.is_superuser && b.is_superuser) return 1;
          if (a.is_active && !b.is_active) return -1;
          if (!a.is_active && b.is_active) return 1;
          return 0;
        });

        setUsers(orderedUsers);
      } else {
        console.error('Failed to fetch users');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleDelete = async (userId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-users/${userId}/`, {
        method: 'DELETE',
      });
      if (response.ok) {
        alert('User deleted successfully!');
        fetchUsers(); // Refresh the list
      } else {
        console.error('Failed to delete user');
      }
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };



  const handleApprove = async (userId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-users/${userId}/approve/`, {
        method: 'PATCH',
      });
      if (response.ok) {
        alert('User approved successfully!');
        fetchUsers(); // Refresh the list
      } else {
        console.error('Failed to approve user');
      }
    } catch (error) {
      console.error('Error approving user:', error);
    }
  };

  const handleDisapprove = async (userId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-users/${userId}/disapprove/`, {
        method: 'PATCH',
      });
      if (response.ok) {
        alert('User disapproved successfully!');
        fetchUsers(); // Refresh the list
      } else {
        console.error('Failed to disapprove user');
      }
    } catch (error) {
      console.error('Error disapproving user:', error);
    }
  };

  return (
   




<div>
    {/* Navbar */}
    <nav className="navbar navbar-expand-lg navbar-light bg-dark fixed-top">
      <div className="container-fluid">
        <a className="navbar-brand text-light" href="#">Admin</a>
        <button 
          className="navbar-toggler bg-light" 
          type="button" 
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
            <li className="nav-item">
              <Link className="nav-link text-light" to="/admin">
                <FontAwesomeIcon icon={faTachometerAlt} className="me-2" />
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/register-book">
                <FontAwesomeIcon icon={faBook} className="me-2 " />
                Register Book
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/list-users">
                <FontAwesomeIcon icon={faUsers} className="me-2 text-warning" />
                Manage User
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/view-books">
                <FontAwesomeIcon icon={faListCheck} className="me-2" />
                Manage Book
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/adminpurchase">
                <FontAwesomeIcon icon={faCartShopping} className="me-2" />
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light" to="/adminrent">
                <FontAwesomeIcon icon={faBagShopping} className="me-2" />
                Rental History
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto pr-5">
            <li className="nav-item mr-5">
              <Link className="nav-link text-light fixed-right" to="/login">
                <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>


<div className="container content px-5 mt-5 pt-4">
  <h1 className="mb-4">User List</h1>
  <div className="row">
    {users.map((user) => (
      <div className="col-md-5 mb-4" key={user.id}>
        <div className="card shadow-sm border-light rounded">
          <div className="card-body">
            <h5 className="card-title d-flex justify-content-between">
              <span>{user.username}</span>

              <span className={`badge ${user.is_superuser ? 'bg-primary' : user.is_active ? 'bg-success' : 'bg-danger'}`}>
  {user.is_superuser === true ? 'Pending' : user.is_active === true ? 'Approved' : 'Disapproved'}
</span>



            </h5>
            <p className="card-text">
              <strong>First Name:</strong> {user.first_name} <br />
              <strong>Last Name:</strong> {user.last_name} <br />
              <strong>Email:</strong> {user.email} <br />
              <strong>Joined Date:</strong> {new Date(user.date_joined).toLocaleDateString()}
            </p>
            <div className="d-flex flex-wrap">
        
              <button
                className="btn action-btn me-2"
                onClick={() => handleApprove(user.id)}
              >
                <FontAwesomeIcon icon={faCheckCircle} /> Approve
              </button>
              <button
                className="btn action-btn me-2"
                onClick={() => handleDisapprove(user.id)}
              >
                <FontAwesomeIcon icon={faTimesCircle} /> Disapprove
              </button>
              
              <button
                className="btn action-btn "
                onClick={() => handleDelete(user.id)}
              >
                <FontAwesomeIcon icon={faTrash} /> Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

<style jsx>{`


  .content {
    margin-left: 300px;
  }
  @media (max-width: 768px) {
    .vertical-nav {
      width: 100%;
    }
    .content {
      margin-left: 0;
    }
  }
.navbar {
background: #1a1a1a; /* Dark background color */
}

.vertical-nav {
background: #1a1a1a; /* Dark background color */
position: fixed;
top: 56px;
left: 0;
height: calc(100% - 56px);
overflow-y: auto;
padding-top: 30px;
z-index: 999;
}

.vertical-nav .nav-link {
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
padding: 10px 15px;
color: #ff6700; /* Dark orange font color */
transition: background-color 0.3s; /* Smooth hover effect */
}

.vertical-nav .nav-link:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}

.nav-icon {
font-size: 20px;
margin-right: 10px;
color: #ff6700; /* Dark orange for icons */
}

li {
border-bottom: 2px solid black;
}

li:hover {
background-color: #2a2a2a; /* Slightly lighter background for hover effect */
}




body {
position: relative;
margin: 0; /* Remove default margins */
padding: 0; /* Remove default padding */
}

body::before {
content: '';
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
background-size: cover; /* Ensure the image covers the entire body */
opacity: 0.4; /* Apply opacity only to the image */
z-index: -1; /* Place it behind all other content */
}

a {
text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
font-family: "Times New Roman", Times, serif; /* Classic font */
color: #1a1a1a; /* Match the theme color */
}




.card {
    transition: all 0.3s ease-in-out;
    background-color: #fff;
    border-radius: 20px;
  }

  .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  .card-title {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .card-text {
    color: #666;
    font-size: 0.95rem;
  }


  .badge {
    font-size: 0.9rem;
    padding: 5px 10px;
  }






  .action-btn {
    flex: 1; /* Ensures all buttons have equal width */
    margin: 0; /* Remove default margins */    margin-bottom: 10px; /* Add spacing for stacked buttons on smaller screens */
    background: linear-gradient(45deg, #ff6700, #ff9500);
    color: white;
    border: none;
    transition: transform 0.2s, box-shadow 0.2s;
    font-size: small;
  }

  .action-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    .action-btn {
      width: 100%; /* Make buttons full width on smaller screens */
    }
  }

`}</style>
</div>

  );
};

export default ListUserPage;
